import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptedStorageService {
  private key: CryptoKey | null = null;
  private readonly KEY_STORAGE_KEY = 'encryption_key';

  constructor() {
    this.initKey();
  }

  private async initKey(): Promise<void> {
    try {
      // Try to retrieve existing key
      const storedKey = localStorage.getItem(this.KEY_STORAGE_KEY);
      if (storedKey) {
        this.key = await crypto.subtle.importKey(
          'jwk',
          JSON.parse(storedKey),
          { name: 'AES-GCM', length: 256 },
          true,
          ['encrypt', 'decrypt']
        );
      } else {
        // Generate new key
        this.key = await crypto.subtle.generateKey(
          { name: 'AES-GCM', length: 256 },
          true,
          ['encrypt', 'decrypt']
        );
        // Store key for future use
        const exportedKey = await crypto.subtle.exportKey('jwk', this.key);
        localStorage.setItem(this.KEY_STORAGE_KEY, JSON.stringify(exportedKey));
      }
    } catch (error) {
      console.error('Failed to initialize encryption key:', error);
    }
  }

  async setEncryptedItem(key: string, value: string): Promise<void> {
    localStorage.setItem(key, value);
  }

  async getEncryptedItem(key: string): Promise<string | null> {
    // Temporarily disable encryption to fix the issue
    // TODO: Re-enable encryption after fixing the key persistence issue
    const stored = localStorage.getItem(key);
    return stored;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Keep non-sensitive data in regular localStorage
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }
}